export default "__VITE_ASSET__Cw21$eDs__"